/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Copy_TextInputs */



/**
* | output |
* | --- |
* | "Copy Text" |
*
* @param {Context_Menu_Copy_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_copy_text = /** @type {((inputs?: Context_Menu_Copy_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Copy_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier le texte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Text kopieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia testo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скопировать текст")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar texto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("复制文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキストをコピー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेक्स्ट कॉपी करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Copiar texto")
	return /** @type {LocalizedString} */ ("Copy Text")
});